import script from "./informationList.vue?vue&type=script&setup=true&lang=js"
export * from "./informationList.vue?vue&type=script&setup=true&lang=js"

import "./informationList.vue?vue&type=style&index=0&id=45957649&scoped=true&lang=postcss"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45957649"]])

export default __exports__